<template>
<div class="layer-project" data-project-name="haevichi"><!-- Project Name -->
    <div class="layer-project-detail">
        <!-- Page Contents -->
        <section class="project-visual">
            <div>
                <h1 class="project-tit"><span class="award11"></span>Haevichi <span class="ib">Hotel &amp; Resort</span></h1>
                <a href="http://www.haevichi.com" class="link" target="_blank">www.haevichi.com</a>
            </div>
        </section>
        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">해비치는 현대자동차그룹의 대표적인 호스피탈리티 계열사로 대한민국의 호텔 및 서비스 산업을 선도하고 있습니다. <br>아름다운 제주의 풍경과 최고급 시설의 호텔 &amp; 리조트를 소개하기 위해 고해상도의 이미지와 객실사진 등을 적극 활용하여 구성하였습니다.
                <br>골프장은 사용자에게 코스를 쉽게 소개하기 위해 일러스트로 제작하여 코스별 상세 정보를 제공하고 있습니다.</p>
                <div class="project-overview-diagram">
                    <p class="diagram01">The Value of Relaxing Life</p>
                    <p class="diagram02">
                        <ul>
                            <li>Rest</li>
                            <li>Travel</li>
                            <li>Relax</li>
                        </ul>
                    </p>
                    <p class="diagram03">Haevichi <span class="ib">Hotel &amp; Resort</span></p>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="section section01">
            <div class="inner-section">
                <strong class="project-subtit">PC Web</strong>
                <p>호텔 &amp; 리조트의 전경과 주변의 아름다운 풍경을 키 비주얼 이미지로 활용하여 시각적 효과를 극대화하고, 콘텐츠는 Special offers와 Event를 중심으로 구성하였습니다. 
                <br>다른 리조트 사이트로의 이동을 위해 상단에 버튼을 배치하였고, 여행지 현지의 날씨 정보도 볼 수 있도록 구성했습니다. 
                <br>전체적으로 고급스러운 호텔의 이미지를 전달하기 위해서 Gold Beige와 Dark Gray를 메인 컬러로 사용했습니다.</p>
            </div>
        </section>
        <section class="section full pc-web-img">
            <div class="img">
                <img src="" alt="" data-src="/static/img/project-detail/haevichi/pc-web-img@m.png">
            </div>
            <p class="text">Haevichi Hotel &amp; Resort Jeju</p>
        </section>
        <section class="section full section02">
            <strong class="kids-tit">The Best place for a <br>Relaxing Time</strong>
            <!-- Swiper -->
            <div class="section02-slider swiper-container">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/haevichi/kids-img-01@m.jpg">
                    </li>
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/haevichi/kids-img-02@m.jpg">
                    </li>
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/haevichi/kids-img-03@m.jpg">
                    </li>
                    <li class="swiper-slide">
                        <img src="" alt="" data-src="/static/img/project-detail/haevichi/kids-img-04@m.jpg">
                    </li>
                </ul>
                
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
            </div>
        </section>
        
        <section class="section section03">
            <div class="inner-section">
                <strong class="project-subtit">Mobile Web</strong>
                <div class="img">
                    <img src="" alt="" data-src="/static/img/project-detail/haevichi/mobile-web-img@m.png">
                </div>
                <div class="section03-list">
                    <ul>
                        <li>
                            <strong class="sub-title"><span>Dining</span></strong>
                            <div class="sub-img">
                                <img src="" alt="" data-src="/static/img/project-detail/haevichi/dining-img@m.png">
                            </div>
                        </li>
                        <li>
                            <strong class="sub-title"><span>Leisure &amp; Relaxation</span></strong>
                            <div class="sub-img">
                                <img src="" alt="" data-src="/static/img/project-detail/haevichi/leisure-relaxation-img@m.png">
                            </div>
                        </li>
                        <li>
                            <strong class="sub-title"><span>Special Offers</span></strong>
                            <div class="sub-img">
                                <img src="" alt="" data-src="/static/img/project-detail/haevichi/special-offers-img@m.png">
                            </div>
                        </li>
                        <li>
                            <strong class="sub-title"><span>About Us</span></strong>
                            <div class="sub-img">
                                <img src="" alt="" data-src="/static/img/project-detail/haevichi/about-us-img@m.png">
                            </div>
                        </li>
                        <li>
                            <strong class="sub-title"><span>Recruit</span></strong>
                            <div class="sub-img">
                                <img src="" alt="" data-src="/static/img/project-detail/haevichi/recruit-img@m.png">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        
        <section class="section section04">
            <div class="inner-section">
                <div class="map01">
                    <img src="" alt="" data-src="/static/img/project-detail/haevichi/map-img-01@m.png">
                </div>
                <div class="map-bottom">
                    <div class="map02">
                        <img src="" alt="" data-src="/static/img/project-detail/haevichi/map-img-02@m.png">
                    </div>
                    <div class="map03">
                        <img src="" alt="" data-src="/static/img/project-detail/haevichi/map-img-03@m.png">
                    </div>
                </div>
            </div>
        </section>
        <section class="project-client"><strong class="a11y-hidden">Haevichi Hotel &amp; Resort</strong></section>
        <!-- Page Contents -->
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var swiper = new Swiper(".section02-slider", {
			slidesPerView: "auto",
			spaceBetween: 26,
			//centeredSlides: true,
			loop: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				// when window width is <= 712px
				711: {
					centeredSlides: true,
					spaceBetween: 12,
				},
				1279: {
					spaceBetween: 13,
				},
			},
		});
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/haevichi/ci.png) 50% / auto 57px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/haevichi/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/haevichi/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 69px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/haevichi/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 138px;
	}
}

/* Overview */
.project-overview {
	background-color: #b7ad96;
	color: #fff;
}
.project-overview-txt {
	line-height: 2.1rem;
	margin-bottom: 20px;
}
.project-overview-diagram {
	font-weight: 500;
	text-align: center;
}
.project-overview-diagram p {
	position: relative;
	font-size: 1.8rem;
	color: #f2f0e0;
}
.project-overview-diagram li {
	position: relative;
	width: 9.5rem;
	height: 9.5rem;
	font-size: 1.3rem;
	line-height: 9.5rem;
	margin: 10px auto;
	background-color: #f2f0df;
	color: #222;
	border-radius: 50%;
}
.project-overview-diagram li + li:before {
	content: "";
	position: absolute;
	top: -10px;
	left: calc(50% - 1px);
	width: 2px;
	height: 10px;
	background-color: #f2f0df;
}
.project-overview-diagram .diagram01:after,
.project-overview-diagram .diagram03:before {
	content: "";
	display: block;
	width: 2px;
	height: 23px;
	background-color: #f2f0df;
}
.project-overview-diagram .diagram01:after {
	margin: 10px auto 0;
}
.project-overview-diagram .diagram03:before {
	margin: 0 auto 10px;
}

@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 30px;
	}
	.project-overview-diagram {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.project-overview-diagram:after,
	.project-overview-diagram ul:after {
		content: "";
		display: block;
		clear: both;
	}
	.project-overview-diagram p {
		font-size: 15px;
	}
	.project-overview-diagram .diagram01 {
		flex: 1.5;
		width: 131px;
		padding-right: 31px;
		text-align: left;
	}
	.project-overview-diagram .diagram02 {
		width: 355px;
	}
	.project-overview-diagram li {
		float: left;
		width: 105px;
		height: 105px;
		font-size: 17px;
		line-height: 105px;
		margin: 0;
	}
	.project-overview-diagram li + li {
		margin-left: 20px;
	}
	.project-overview-diagram li + li:before {
		top: 50%;
		left: -20px;
		width: 20px;
		height: 1px;
	}
	.project-overview-diagram .diagram03 {
		flex: 1.5;
		width: 146px;
		padding-left: 31px;
	}

	.project-overview-diagram .diagram01:after,
	.project-overview-diagram .diagram03:before {
		position: absolute;
		top: 50%;
		height: 1px;
		margin: 0;
	}
	.project-overview-diagram .diagram01:after {
		width: 36px;
		right: 0;
	}
	.project-overview-diagram .diagram03:before {
		width: 31px;
		left: 0;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		max-width: 1280px;
		padding: 40px 20px;
	}
	.project-overview-tit {
		margin-bottom: 20px;
	}
	.project-overview-txt {
		margin-bottom: 50px;
		line-height: 1.8;
	}
	.project-overview-diagram p {
		font-size: 18px;
	}
	.project-overview-diagram .diagram01 {
		flex: auto;
		width: 280px;
		margin-right: 20px;
		padding-right: 50px;
	}
	.project-overview-diagram .diagram02 {
		width: 638px;
	}
	.project-overview-diagram li {
		width: 190px;
		height: 190px;
		font-size: 20px;
		line-height: 190px;
	}
	.project-overview-diagram li + li {
		margin-left: 34px;
	}
	.project-overview-diagram li + li:before {
		top: calc(50% - 1px);
		left: -35px;
		width: 35px;
		height: 2px;
	}
	.project-overview-diagram .diagram03 {
		flex: auto;
		width: 280px;
		margin-left: 20px;
		padding-left: 50px;
		text-align: right;
	}

	.project-overview-diagram .diagram01:after {
		top: calc(50% - 1px);
		width: 50px;
		height: 2px;
	}
	.project-overview-diagram .diagram03:before {
		top: calc(50% - 1px);
		width: 50px;
		height: 2px;
	}
}

/* PC Web */
.section01 .project-subtit {
	margin-bottom: 20px;
	font-size: 2.8rem;
}
.section01 p {
	word-break: keep-all;
}
.layer-project-detail > section.pc-web-img {
	padding-top: 0;
}
.pc-web-img {
	text-align: center;
}
.pc-web-img .text {
	padding: 30px 0;
	font-size: 2rem;
}

@media screen and (min-width: 712px) {
	.layer-project-detail > section.section01 {
		padding-top: 70px;
		padding-bottom: 80px;
	}
	.pc-web-img .img {
		padding: 0 15px;
	}
	.pc-web-img .text {
		padding: 50px 0;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section01 {
		padding-bottom: 90px;
	}
	.section01 .project-subtit {
		font-size: 56px;
	}
	.section01 p {
		font-size: 16px;
	}
	.pc-web-img .img {
		position: relative;
		height: 1151px;
		padding: 0;
	}
	.pc-web-img .img img {
		position: absolute;
		top: 0;
		left: 50%;
		max-width: none;
		transform: translateX(-50%);
	}
	.pc-web-img .text {
		padding-bottom: 80px;
		font-size: 26px;
	}
}

.section02 {
	position: relative;
	text-align: center;
	background-color: #f8f7ef;
}
.section02:before {
	content: "";
	position: absolute;
	top: -15px;
	left: 50%;
	width: 1px;
	height: 30px;
	background-color: #c4bca8;
}
.kids-tit {
	display: block;
	font-size: 2.2rem;
	line-height: 1.2;
	font-weight: 400;
	margin-bottom: 35px;
}
.section02-slider {
	padding-bottom: 40px;
}

@media screen and (max-width: 711px) {
	.section02-slider li {
		width: 78.90625vw;
		max-width: 505px;
	}
}
@media screen and (min-width: 712px) {
	.section02-slider {
		padding-left: 9.6207vw;
	}
	.section02-slider li {
		width: 39.3258vw;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.full {
		padding-bottom: 90px;
	}
	.kids-tit {
		margin-top: 50px;
		margin-bottom: 60px;
		font-size: 36px;
	}
	.section02:before {
		top: -30px;
		height: 60px;
	}
	.section02-slider {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 65px;
		padding-right: 65px;
		padding-bottom: 50px;
		overflow: visible;
	}
	.section02-slider li {
		width: 561px;
	}
}

/* Mobile Web */
.section03 {
	background: url(/static/img/project-detail/haevichi/mobile-web-bg@m.jpg) 0 0/100%
		auto no-repeat;
}
.section03 .img {
	text-align: center;
}
.section03-list li {
	position: relative;
}
.section03-list li .sub-title {
	display: block;
	position: relative;
	width: 100%;
	margin-bottom: 35px;
	font-size: 4.0625vw;
	font-weight: 400;
	line-height: 1.2;
}
.section03-list li .sub-title:before {
	content: "";
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	height: 1px;
	background-color: #ddd;
}
.section03-list li .sub-title span {
	display: inline-block;
	position: relative;
	padding-right: 7px;
	background-color: #fff;
}

@media screen and (max-width: 711px) {
	.layer-project-detail > section.section03 {
		padding-left: 0;
		padding-right: 0;
	}
	.section03 .project-subtit {
		text-align: center;
	}
	.section03-list {
		padding-left: 15px;
	}
	.section03-list li .sub-img {
		position: relative;
		height: 373px;
	}
	.section03-list li .sub-img img {
		position: absolute;
		top: 0;
		left: 12.8vw;
		max-width: none;
		height: 100%;
	}
}
@media screen and (min-width: 712px) {
	.section03 {
		background-image: url(/static/img/project-detail/haevichi/mobile-web-bg@t.jpg);
	}
	.section03 .img img {
		width: 86.7977vw;
	}
	.section03 .project-subtit {
		margin-top: 10px;
		font-size: 28px;
	}
	.section03-list {
		padding-top: 40px;
	}
	.section03-list li + li {
		margin-top: 60px;
	}
	.section03-list li .sub-title {
		position: absolute;
		top: calc(50% - 34px);
		font-size: 14px;
	}
	.section03-list li .sub-img {
		position: relative;
	}
	.section03-list li .sub-img img {
		max-width: 65.028vw;
	}

	.section03-list li:nth-child(2) .sub-title,
	.section03-list li:nth-child(4) .sub-title {
		text-align: right;
	}

	.section03-list li:nth-child(1) .sub-title:before {
		background-color: #f5f5f5;
	}
	.section03-list li:nth-child(2) .sub-title:before {
		background-color: #dadada;
	}
	.section03-list li:nth-child(3) .sub-title:before {
		background-color: #d9d9d9;
	}
	.section03-list li:nth-child(4) .sub-title:before {
		background-color: #d6d6d6;
	}
	.section03-list li:nth-child(5) .sub-title:before {
		background-color: #dadada;
	}

	.section03-list li:nth-child(1) .sub-img,
	.section03-list li:nth-child(3) .sub-img,
	.section03-list li:nth-child(5) .sub-img {
		text-align: right;
		right: -3.5112vw;
	}

	.section03-list li:nth-child(2) .sub-img,
	.section03-list li:nth-child(4) .sub-img {
		left: -3.7921vw;
	}

	.section03-list li:nth-child(2) .sub-title span,
	.section03-list li:nth-child(4) .sub-title span {
		padding-left: 7px;
		padding-right: 0;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		background-image: url(/static/img/project-detail/haevichi/mobile-web-bg@w.jpg);
	}
	.section03 .img {
		text-align: center;
	}
	.section03 .img img {
		width: auto;
	}

	.section03 .project-subtit {
		margin-bottom: 40px;
		font-size: 56px;
	}
	.section03-list li .sub-title {
		top: calc(50% - 50px);
	}
	.section03-list li .sub-title span {
		font-size: 18px;
		padding-right: 30px;
	}

	.section03-list li:nth-child(1) .sub-img,
	.section03-list li:nth-child(3) .sub-img,
	.section03-list li:nth-child(5) .sub-img {
		text-align: right;
		right: -70px;
	}

	.section03-list li:nth-child(2) .sub-title span,
	.section03-list li:nth-child(4) .sub-title span {
		padding-left: 30px;
	}
}

/* Map image area */
.layer-project .layer-project-detail > section.section04 {
	padding-top: 15px;
}
.section04 {
	background-color: #f8f7ef;
}
.section04 .map02 {
	padding-top: 30px;
}
.section04 .map03 {
	padding-top: 40px;
}
@media screen and (min-width: 712px) {
	.layer-project .layer-project-detail > section.section04 {
		padding-top: 63px;
		padding-bottom: 50px;
	}
	.section04 .map-bottom:after {
		content: "";
		display: block;
		clear: both;
	}
	.section04 .map-bottom > div {
		width: 50%;
	}
	.section04 .map02 {
		float: left;
		padding-right: 10px;
	}
	.section04 .map03 {
		float: right;
		padding-top: 30px;
		padding-left: 10px;
		text-align: right;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project .layer-project-detail > section.section04 {
		padding-top: 120px;
		padding-bottom: 100px;
	}
	.section04 .map-bottom > div {
		padding-top: 50px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/haevichi.vue